import { render, staticRenderFns } from "./SubscriptionConfirmation.vue?vue&type=template&id=3b2604de&scoped=true"
import script from "./SubscriptionConfirmation.vue?vue&type=script&lang=ts"
export * from "./SubscriptionConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./SubscriptionConfirmation.vue?vue&type=style&index=0&id=3b2604de&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b2604de",
  null
  
)

export default component.exports